export const RESET_CHANNELS = 'RESET_CHANNELS'
export const RESET_CHANNELINFO = 'RESET_CHANNELINFO'
export const RESET_MESSAGES = 'RESET_MESSAGES'
export const QUIT_CHAT = 'QUIT_CHAT'
export const SET_CHATBAR = 'SET_CHATBAR'
export const SET_FIRMCOUNTS = 'SET_FIRMCOUNTS'
export const GET_UNREAD = 'GET_UNREAD'
export const JOIN_CHANNEL = 'JOIN_CHANNEL'
export const LEAVE_CHANNEL = 'LEAVE_CHANNEL'
export const SET_USER = 'SET_USER'
export const SET_A_MYCHANNEL = 'SET_A_MYCHANNEL'
export const SET_A_CHANNEL = 'SET_A_CHANNEL'
export const SET_A_REQUEST = 'SET_A_REQUEST'
export const SET_HANDLER = 'SET_HANDLER'
export const SET_A_MESSAGE = 'SET_A_MESSAGE'
export const SET_CHANGED = 'SET_CHANGED'
export const SET_TYPING = 'SET_TYPING'
export const SET_CHANNELINFO = 'SET_CHANNELINFO'
export const UPDATE_CHANNELINFO = 'UPDATE_CHANNELINFO'
export const RESET_FOUND_MEMBERS = 'RESET_FOUND_MEMBERS'
export const SET_FOUND_MEMBER = 'SET_FOUND_MEMBER'
export const SET_FOUND_MEMBERS = 'SET_FOUND_MEMBERS'
export const ADD_MEMBERS = 'ADD_MEMBERS'



// WEBPACK FOOTER //
// ./src/store/modules/chat/types.js